import React from "react";
import Brochure from '../../pdf/economic_scale_brochure.pdf';

import '../../Style.css';


import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";
import { IoMdDownload } from "react-icons/io";


import minitableimg_7 from '../../Assets/Images/Economic Scales/Mini Table Top Scale/micro.png'


function Micro() {
    return (
        <div>


            {/* ==========================section-2=========================================== */}
            <section className="py-5">
                <div className="container py-5">
                    <div className="row  justify-content-center align-items-center">
                        <div className="col-lg-6 text-center">
                            <div className=" h-100 ">
                                <p className="section-top-heading-css text-center py-3 py-lg-0">
                                    Eco Mini Scale
                                </p>

                                <div className="text-center image-stretch-css">
                                    <img className="category-details-image-css" src={minitableimg_7} />
                                </div>
                                <div className="">
                                    <p className="about-card-para-css">Capacity : 10 kg</p>
                                    <p className="about-card-para-css">Accuracy : 1 g</p>
                                    <p className="about-card-para-css">Platter Size ( mm ) : 185 x 150</p>
                                </div>

                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <a href="https://wa.me/919443030062" target="_blank" className="" >
                                        <button className="btn CTA-button-css me-4">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                        </button>
                                    </a>
                                    <a href="tel:+91 94430 30062" target="_blank" className="" >
                                        <button className="btn CTA-button-css ">Call Now <IoCall className="ms-2 button-icon-css" />
                                        </button>
                                    </a>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div className="container ">
                    <div className="row row-cols-lg-3 row-cols-1 justify-content-center ">
                        <div className="col">
                            <div>
                                <p className="about-card-heading-css text-center">
                                    Features
                                </p>
                            </div>
                            <div class="et_pb_text">
                                <ol>

                                    <li><span class="number_divider">1</span>
                                        <p className="numbers-list-para-css">Advanced Micro Controller Design
                                        </p>
                                    </li>
                                    <li><span class="number_divider">2</span>
                                        <p className="numbers-list-para-css">Auto Zero Tracking
                                        </p>
                                    </li>
                                    <li><span class="number_divider">3</span>
                                        <p className="numbers-list-para-css">Very Low Power Consumption
                                        </p>
                                    </li>
                                    <li><span class="number_divider">4</span>
                                        <p className="numbers-list-para-css">Inbuilt Battery Backup
                                        </p>
                                    </li>
                                    <li><span class="number_divider">5</span>
                                        <p className="numbers-list-para-css">Overload Indication
                                        </p>
                                    </li>
                                    <li><span class="number_divider">6</span>
                                        <p className="numbers-list-para-css">Software Calibration
                                        </p>
                                    </li>
                                    <li><span class="number_divider">7</span>
                                        <p className="numbers-list-para-css">High Precision Load Cell
                                        </p>
                                    </li>
                                </ol>
                            </div>

                        </div>

                        <div className="col">
                            <div>
                                <p className="about-card-heading-css text-center ">
                                    Specification

                                </p>
                            </div>
                            <div class="et_pb_text">
                                <ol>

                                    <li><span class="number_divider">1</span>
                                        <p className="numbers-list-para-css">Power : 220V AC +10V, 50HZ
                                        </p>
                                    </li>
                                    <li><span class="number_divider">2</span>
                                        <p className="numbers-list-para-css">Battery : 6V / 4.5Ah DC
                                        </p>
                                    </li>
                                    <li><span class="number_divider">3</span>
                                        <p className="numbers-list-para-css">temperature : 10&#8451; to 40&#8451;
                                        </p>
                                    </li>
                                    <li><span class="number_divider">4</span>
                                        <p className="numbers-list-para-css">Display :  6 Digit | 7 Seqment | 13 Min
                                        </p>
                                    </li>
                                    <li><span class="number_divider">5</span>
                                        <p className="numbers-list-para-css">Power Consumption : 6 Watts
                                        </p>
                                    </li>
                                    {/* <li><span class="number_divider">6</span>
                                        <p className="numbers-list-para-css">
                                        </p>
                                    </li>
                                    <li><span class="number_divider">7</span>
                                        <p className="numbers-list-para-css">
                                        </p>
                                    </li> */}
                                </ol>
                            </div>

                        </div>

                        <div className="col">
                            <div>
                                <p className="about-card-heading-css text-center ">
                                    Options

                                </p>
                            </div>
                            <div class="et_pb_text">
                                <ol>

                                    <li><span class="number_divider">1</span>
                                        <p className="numbers-list-para-css">
                                            Parallel Display | Poll Display
                                        </p>
                                    </li>
                                    <li><span class="number_divider">2</span>
                                        <p className="numbers-list-para-css">Piece - Counting Facility | Memory Accumulation
                                        </p>
                                    </li>
                                    <li><span class="number_divider">3</span>
                                        <p className="numbers-list-para-css">RS - 232 Interface with Computer | Printer
                                        </p>
                                    </li>
                                    <li><span class="number_divider">4</span>
                                        <p className="numbers-list-para-css">Backrail for heavy duty platform scale
                                        </p>
                                    </li>
                                    {/* <li><span class="number_divider">5</span>
                                        <p className="numbers-list-para-css">Overload Indication
                                        </p>
                                    </li>
                                    <li><span class="number_divider">6</span>
                                        <p className="numbers-list-para-css">Software Calibration
                                        </p>
                                    </li>
                                    <li><span class="number_divider">7</span>
                                        <p className="numbers-list-para-css">High Precision Load Cell
                                        </p>
                                    </li> */}
                                </ol>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="container col-lg-8 ">
                    <div className="row row-cols-lg-2 row-cols-1 justify-content-center g-4 pt-4">
                        <div className="col">
                            <div className="about-small-card-css card h-100 p-4">
                                {/* <VscWorkspaceTrusted className="about-icon-css mb-3" /> */}
                                <p className="about-card-heading-css">
                                    Manufactured By
                                </p>
                                <ul className="footer-ul-css px-0">
                                    <li className="">
                                        Benson Weighing Systems, Madurai
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div className="about-small-card-css card h-100 p-4">
                                {/* <VscWorkspaceTrusted className="about-icon-css mb-3" /> */}
                                <p className="about-card-heading-css">
                                    Marketed By</p>
                                <ul className="footer-ul-css px-0">
                                    <li className="">
                                        Economic Scales
                                    </li>
                                    <li>
                                        58/ F1, Munichalai Road,
                                    </li>
                                    <li>
                                        Near Corporation Hospital,

                                    </li>
                                    <li>
                                        Madurai, Tamil Nadu 625009

                                    </li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="container pt-5">
                    <div className="row justify-content-center text-center align-items-center">
                        <div className="col-lg-8">
                            {/* <p className="about-card-para-css">Specifications are subject to change for improvement without prior notice.
                                Complies Wit Rules & Regulations Of Department Of Consumer Affairs, Govt.India</p> */}
                            <a href={Brochure} target="_blank">
                                <button className="btn more-btn-css-styling "> Download Brochure <IoMdDownload className="ms-2 button-icon-css" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

            </section>

        </div >

    );
}

export default Micro;
